<div class="content-p">
    <!-- <div id="pageFooter">Page</div> -->
    <div
        style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        "
    >
        <div>
            <div class="c-content" style="display: flex; margin-bottom: 10px">
                <div style="min-width: 80px; height: 80px; margin-right: 20px">
                    <img
                        src="../../../assets/img/logo.png"
                        alt=""
                        style="width: 80px; height: 80px"
                    />
                </div>
                <div style="width: 78%">
                    <div style="font-size: 16px; font-weight: 600">
                        บริษัท กะเพรา เอ็กซ์เพรส จำกัด (สำนักงานใหญ่)
                    </div>
                    <div style="font-size: 12px">
                        9 ซอยรามอินทรา 5 แยก 15 แขวง อนุสาวรีย์ เขต บางเขน
                    </div>
                    <div style="font-size: 12px">กรุงเทพมหานคร 10220</div>
                    <div style="font-size: 12px">โทรศัพท์: 099-268-0711</div>
                </div>
                <div style="display: flex; width: 94%; place-content: flex-end">
                    <div
                        style="
                            display: flex;
                            flex-direction: column;
                            align-items: flex-end;
                            align-self: flex-end;
                            right: 20px;
                            gap: 4px;
                        "
                    >
                        <div
                            style="
                                width: 50%;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                            "
                        ></div>
                        <div style="display: flex">
                            <div style="margin-right: 4px">
                                วันที่สร้าง / Create date.
                            </div>
                            <div style="width: 200px; border-bottom: 1px solid">
                                {{ pData?.createTime }}
                            </div>
                        </div>
                        <div style="display: flex">
                            <div style="margin-right: 4px">
                                สร้างโดย / Create by.
                            </div>
                            <div style="width: 200px; border-bottom: 1px solid">
                                {{ pData?.createBy }}
                            </div>
                        </div>
                        <div style="display: flex">
                            <div style="margin-right: 4px">เลขที่ / No.</div>
                            <div style="width: 200px; border-bottom: 1px solid">
                                {{
                                    pData.status == "PENDING" ||
                                    pData.status == "REJECT"
                                        ? pData.purReq
                                        : pData.purOrder
                                }}
                            </div>
                        </div>
                        <div style="display: flex">
                            <div style="margin-right: 4px">สถานะ / Status.</div>
                            <div style="width: 200px; border-bottom: 1px solid">
                                {{ pData?.status }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="margin-left: 40px; display: flex; margin: 20px 0">
                <div
                    style="
                        width: 100%;
                        display: flex;
                        justify-content: space-around;
                        margin-left: 40px;
                    "
                >
                    <div
                        style="
                            margin-right: 7px;
                            display: flex;
                            align-items: center;
                        "
                    >
                        <div
                            class="box"
                            [ngClass]="{
                                x:
                                    pData.status == 'PENDING' ||
                                    pData.status == 'REJECT'
                            }"
                        ></div>
                        ใบขอซื้อ / Purchase Requestion
                    </div>
                    <div
                        style="
                            margin-right: 10px;
                            display: flex;
                            align-items: center;
                        "
                    >
                        <div
                            class="box"
                            [ngClass]="{ x: pData.status == 'APPROVE' }"
                        ></div>
                        ใบสั่งซื้อ / Purchase Order
                    </div>
                    <div
                        style="
                            margin-right: 10px;
                            display: flex;
                            align-items: center;
                        "
                    >
                        <div
                            class="box"
                            [ngClass]="{ x: pData.status == 'RECEIVED' }"
                        ></div>
                        ใบรับสินค้า / Receipt order
                    </div>
                </div>
            </div>
            <div style="margin-left: 40px; display: flex">
                <div style="width: 100%; display: flex; margin-bottom: 10px">
                    <div style="margin-right: 7px">
                        ชื่อผู้จำหน่าย / Supplier Name:
                    </div>
                    <div>{{ (pData?.suppName)[selectedLang] }}</div>
                </div>
                <div style="display: flex; width: 100%">
                    <div style="margin-right: 7px">
                        ข้อมูลผู้ติดต่อ / Contact:
                    </div>
                    <div>
                        {{
                            (pData?.suppDetail)[0].contact.phone == ""
                                ? "-"
                                : (pData?.suppDetail)[0].contact.phone
                        }}
                        <span *ngIf="(pData?.suppDetail)[0].contact.contactName"
                            >({{
                                (pData?.suppDetail)[0].contact.contactName
                            }})</span
                        >
                    </div>
                </div>
            </div>
            <div style="margin-left: 40px; display: flex; margin-bottom: 10px">
                <div style="width: 100%; display: flex">
                    <div style="margin-right: 7px">
                        ที่อยู่ / Supplier Address:
                    </div>
                    <div>
                        {{
                            (pData?.suppDetail)[0].contact.address == ""
                                ? "-"
                                : (pData?.suppDetail)[0].contact.address
                        }}
                    </div>
                </div>
            </div>
            <div style="margin-left: 40px; display: flex">
                <table style="width: 100%">
                    <thead>
                        <tr>
                            <th class="text-center">ลำดับ / No.</th>
                            <th class="text-center">รายการ / Descriptions</th>
                            <th class="text-center">จำนวน / Quantity</th>
                            <th class="text-center">
                                ราคาต่อหน่วย / Unit Price
                            </th>
                            <th class="text-center">ราคารวม / Total Price</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of pData.list; let i = index">
                            <td class="text-center">
                                {{ item.mpID ? i + 1 : "" }}
                            </td>
                            <td class="text-left">
                                {{ item.mpName[selectedLang] }}
                            </td>
                            <td class="text-center">
                                <div
                                    style="
                                        display: flex;
                                        height: 100%;
                                        justify-content: center;
                                    "
                                >
                                    {{
                                        pData.status != "RECEIVED"
                                            ? item.quantity
                                            : item.actualQuantity
                                    }}
                                    <span *ngIf="item.mpID"
                                        >({{
                                            item.unitName[selectedLang]
                                        }})</span
                                    >
                                </div>
                            </td>
                            <td class="text-right">
                                <div
                                    style="
                                        display: flex;
                                        height: 100%;
                                        justify-content: flex-end;
                                    "
                                >
                                    {{ item.pricePerUnit | number : "1.2-2" }}
                                </div>
                            </td>
                            <td class="text-right">
                                <div
                                    style="
                                        display: flex;
                                        height: 100%;
                                        justify-content: flex-end;
                                    "
                                >
                                    {{ item.totalR | number : "1.2-2" }}
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="text-right" colspan="4">
                                ราคารวม (บาท) / Total Price (Baht)
                            </td>
                            <td
                                class="text-right"
                                style="justify-content: right; margin-top: 10px"
                            >
                                {{ pData.summaryTotal | number : "1.2-2" }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div style="margin-bottom: 30px">
            <div>
                <div style="margin-left: 40px; display: flex; margin-top: 10px">
                    <div style="width: 220px">หมายเหตุเพิ่มเติม / Remark:</div>
                    <div style="border-bottom: 1px solid; width: 100%">
                        <span *ngIf="pData.status == 'REJECT'">
                            {{ pData.reason }}
                        </span>
                    </div>
                </div>
                <div style="margin-left: 40px; display: flex; margin-top: 25px">
                    <div style="border-bottom: 1px solid; width: 100%"></div>
                </div>
            </div>
        </div>
    </div>
</div>
